export default __webpack_public_path__ + "static/media/property_758.439edfb9.png";